import { useCallback, useMemo } from 'react'
import { ViewSearchOptions, ActiveFilterT } from 'ui-io/task-io/task-search'

import { parseFilterString } from './task-filter'

const useTableFilters = (
  viewSearchOptions: ViewSearchOptions,
  activeFilterString: string | undefined,
  updateFilterInUrl: (updatedFilter?: ActiveFilterT) => void,
): [ActiveFilterT, (filters: ActiveFilterT) => void, () => void] => {
  const appliedFilters: ActiveFilterT = useMemo(
    () => parseFilterString(viewSearchOptions, activeFilterString),
    [activeFilterString, viewSearchOptions],
  )
  const setFilters = useCallback(
    (filters: ActiveFilterT) => {
      // remove keys with empty arrays as values
      const toSet: ActiveFilterT = Object.fromEntries(
        Object.entries(filters ?? {}).filter(([, values]) => !!values),
      )
      updateFilterInUrl(Object.keys(toSet).length ? toSet : undefined)
    },

    [updateFilterInUrl],
  )
  const clearFilters = useCallback(() => {
    updateFilterInUrl(undefined)
  }, [updateFilterInUrl])

  return [appliedFilters, setFilters, clearFilters]
}

export default useTableFilters
